import Dropdown from "utils/dropdown/dropdown"

function initDropdown(container, CLASS_NAME) {
  const dropdownContainer = container.querySelector(`.${CLASS_NAME}__dropdown--js`)
  new Dropdown(dropdownContainer).enable()
}

export default initDropdown
